export default __webpack_public_path__ + "static/media/logout_big.72efccee.svg";